import React from 'react';
import PropTypes from 'prop-types';
import InfoBanner from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/InfoBanner';
import {
    ExpandableReviewRow,
    ReviewRow,
} from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/ReviewRows';
import { COST_BANNER_TEXT } from '@/features/datasets/components/DataCollection/GenerateDataWithAI/constants';
import { REVIEW_DESCRIPTION } from '@/features/datasets/components/DataCollection/RetrievalAgent/constants';

/**
 * Retrieval Agent "Review & Initiate" step (Figma 5074:22122): third-party
 * charges warning, then a read-only summary of the configuration.
 */
const ReviewStep = ({ goal, customGuidelines, languages, taskTypeLabel, modelLabel, recordLimit }) => (
    <>
        <InfoBanner text={COST_BANNER_TEXT} />
        <div className="gdai-section">
            <div className="gdai-section-heading fs-unmask">Review & Initiate</div>
            <p className="gdai-field-hint fs-unmask">{REVIEW_DESCRIPTION}</p>
            <ReviewRow label="Goal" value={goal} alignValueLeft />
            <ExpandableReviewRow label="Description" value={customGuidelines} />
            <ReviewRow label="Languages" value={(languages || []).join(', ')} />
            <ReviewRow label="Task Type" value={taskTypeLabel} />
            <ReviewRow label="Model" value={modelLabel} />
            <ReviewRow
                label="Record limit"
                value={
                    Number.isFinite(recordLimit)
                        ? `${recordLimit.toLocaleString('en-US')} records`
                        : null
                }
            />
        </div>
    </>
);

ReviewStep.propTypes = {
    goal: PropTypes.string,
    customGuidelines: PropTypes.string,
    languages: PropTypes.arrayOf(PropTypes.string),
    taskTypeLabel: PropTypes.string,
    modelLabel: PropTypes.string,
    recordLimit: PropTypes.number,
};

export default ReviewStep;
